import { create } from "zustand";

type PixelStoreProps = {
  isPixelLoaded: boolean;
  setIsPixelLoaded: (value: boolean) => void;
};

export const usePixelStore = create<PixelStoreProps>((set) => ({
  isPixelLoaded: false,
  setIsPixelLoaded: (value) => set({ isPixelLoaded: value }),
}));
